import {NgModule} from '@angular/core';
import {JoinPipe} from 'src/app/pipes/join.pipe';
import {SplitPipe} from 'src/app/pipes/split.pipe';
import {FilterPipe} from 'src/app/pipes/filter.pipe';
import {FindPipe} from './find.pipe';
import {IsInPipe} from './is-in.pipe';
import { DurationPipe } from 'src/app/pipes/duration.pipe';
import {ResolveDeploymentSubscription} from 'src/app/pipes/resolve-deployment-subscription';
import { TimeDurationPipe } from './timeDuration.pipe';
import { IsNotInPipe } from './is-not-in.pipe';
import { TrimPipe } from './trim.pipe';
import { CapitalizeFirstPipe } from './capitalize-first.pipe';
import { FormatTextPipe } from './format-text.pipe';
import { TimeAgoPipe } from './time-ago.pipe';
import { TimeDatePipe } from './time-date.pipe';
import { ShortDurationPipe } from './short-duration';

@NgModule({
  declarations: [
    JoinPipe,
    SplitPipe,
    FilterPipe,
    FindPipe,
    IsInPipe,
    IsNotInPipe,
    ResolveDeploymentSubscription,
    DurationPipe,
    TimeDurationPipe,
    TrimPipe,
    CapitalizeFirstPipe,
    FormatTextPipe
  ],
  imports: [
    TimeAgoPipe,
    TimeDatePipe,
    ShortDurationPipe
  ],
  exports: [
    JoinPipe,
    SplitPipe,
    FilterPipe,
    FindPipe,
    IsInPipe,
    IsNotInPipe,
    ResolveDeploymentSubscription,
    DurationPipe,
    TimeDurationPipe,
    TrimPipe,
    CapitalizeFirstPipe,
    FormatTextPipe,
    TimeAgoPipe,
    TimeDatePipe,
    ShortDurationPipe
  ],
  providers: []
})
export class PipesModule {
}
